import Vue from 'vue'

import {
  VBToggle
} from 'bootstrap-vue'

Vue.directive('b-toggle', VBToggle)
